import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

/**
 * Handles root route `/`
 * Checks localStorage for language preference, otherwise uses browser detect
 */
const LanguageRedirector = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // 1. Check local storage for user's explicit preference
    const storedLang = window.localStorage.getItem('preferred_language');
    
    if (storedLang === 'en') {
      navigate('/en', { replace: true });
      return;
    } else if (storedLang === 'es') {
      navigate('/es', { replace: true });
      return;
    }

    // 2. If no explicit preference, detect browser language
    const browserLang = window.navigator.language || window.navigator.userLanguage;
    if (browserLang && browserLang.toLowerCase().startsWith('en')) {
      navigate('/en', { replace: true });
    } else {
      // Default to Spanish for everything else
      navigate('/es', { replace: true });
    }
  }, [navigate]);

  return (
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh', backgroundColor: '#FAFAE4' }}>
      <p style={{ color: '#444728', fontWeight: 500 }}>Cargando idioma / Loading language...</p>
    </div>
  );
};

export default LanguageRedirector;
